import { Link as RouterLink } from "react-router-dom";
import { Box, Paper, Typography } from "@mui/material";
import { ContentFlag } from "~/components/content-flag";
import {
  CanCreate,
  useCanCreate,
} from "~/lib/iam/actions/mondoo/integrations/IntegrationsManager/Create";
import { TRANSITION_SPEED } from "~/pages/integrations/utils/integrationConstants";
import { GradientArrow } from "~/components/GradientArrow/GradientArrow";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";

export type AvailableIntegration = {
  id: string;
  title: string;
  description: string;
  flags?: string[] | null;
};

interface AvailableIntegrationCardProps {
  scope: SpaceScope | OrganizationScope;
  integration: AvailableIntegration;
}

export const AvailableIntegrationCard = ({
  scope,
  integration,
}: AvailableIntegrationCardProps) => {
  const href = `/space/integrations/add/${integration.id}?${scope.params}`;

  const canCreateIntegration = useCanCreate();

  return (
    <Box
      {...(canCreateIntegration ? { component: RouterLink, to: href } : {})}
      height="100%"
    >
      <Paper
        sx={{
          height: 1,
          p: 3,
          minHeight: 216,
          "&:hover": {
            transform: "scale(1.05)",
            transition: TRANSITION_SPEED,
          },
          transition: TRANSITION_SPEED,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography fontSize={24} fontWeight="fontWeightBold">
              {integration.title}
            </Typography>
            {integration.flags?.map((flag) => (
              <ContentFlag
                key={flag}
                flag={flag}
                color="warning"
                layout={{ ml: 2 }}
              />
            ))}
          </Box>

          <CanCreate>
            <GradientArrow />
          </CanCreate>
        </Box>
        <Typography color="text.secondary">
          {integration.description}
        </Typography>
      </Paper>
    </Box>
  );
};
